import { type FC } from 'react';

import { useUserLocale } from '@/i18n/hooks';
import { formatNumber } from '@/util/formatNumber';
import { roundHalfEven } from '@/util/roundHalfEven';

interface Props {
  amount: number;
}

export const ReturnInAmountText: FC<Props> = ({ amount }) => {
  const locale = useUserLocale();

  return (
    <span className="font-details-demibold">{`${formatNumber(
      roundHalfEven(amount, 0),
      locale,
    )}`}</span>
  );
};
